export default __webpack_public_path__ + "static/gift-card-00573fbfbc1c7663d73e9b3362ff3034.png";